import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useEffect, useState } from 'react';
import request from 'src/utils/request';
import loaderGif from '../common/no_bg_loader.gif';

const DraftMailPreview = ({ showPreview, setShowPreview, sendMultiMail, endorsementType = 'ShareEndorsement' }) => {
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<any>(null);
  useEffect(() => {
    fetchPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPreview = () => {
    setPreviewLoading(true);
    request({
      url: 'insurancePolicy/getPolicyQcMailPreview',
      method: 'post',
      data: {
        policyIds: showPreview.checkedItems,
        type: 'QC',
        insuranceCompanyId: showPreview.insuranceCompanyValue,
        insuranceCompanyBranchId: showPreview.insuranceCompanyBranchValue,
        insuranceCompanyBranchContact:
          showPreview?.branchContactValue?.id ?? null,
        otherContact: showPreview?.customEmail ?? null,
        showButton: false
      }
    }).then(
      (response: any) => {
        setPreviewData(response);
        setPreviewLoading(false);
      },
      (error) => {
        setPreviewLoading(false);
        console.log(error);
      }
    );
  };
  const emailSource = showPreview?.customEmail || showPreview?.branchContactValue?.email || "";

  const emailList = emailSource
    .split(",")
    .map((e: string) => e.trim())
    .filter(Boolean);

  const toEmail = emailList[0] || "";
  const ccEmails = emailList.slice(1).join(", ");

  return (
    <Dialog
      open={showPreview.status}
      onClose={() =>
        setShowPreview({
          status: false,
          checkedItems: null,
          endorsementType: null,
          insuranceCompanyValue: null,
          insuranceCompanyBranchValue: null,
          branchContactValue: null,
          customEmail: null
        })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
      scroll="body"
    >
      <DialogTitle id="alert-dialog-title">Mail Preview</DialogTitle>
      <DialogContent
        sx={{
          p: 0,
          overflow: 'visible',
          maxHeight: 'none'
        }}
      >
        {previewLoading ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: 'transparent' }}>
                  <TableCell align="center">
                    <img
                      alt="loader"
                      src={loaderGif}
                      className="loader"
                      width={100}
                      height={100}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        ) : (
          <Box
            sx={{
              p: 2,
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
          >
            <Typography variant="subtitle1" fontWeight={500} mb={1}>
              Mail To: {toEmail}
            </Typography>

            {ccEmails && (
              <Typography variant="subtitle1" fontWeight={500} mb={1}>
                CC: {ccEmails}
              </Typography>
            )}
            <iframe
              title="HTML Preview"
              srcDoc={previewData}
              style={{
                display: 'block',
                width: '100%',
                border: 'none',
                minHeight: '500px'
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => sendMultiMail(showPreview.checkedItems)}
          variant="contained"
          color="primary"
        >
          Create & Share Endorsement
        </Button>
        <Button
          onClick={() =>
            setShowPreview({
              status: false,
              checkedItems: null,
              endorsementType: null,
              insuranceCompanyValue: null,
              insuranceCompanyBranchValue: null,
              branchContactValue: null,
              customEmail: null
            })
          }
          variant="contained"
          color="error"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DraftMailPreview;
